<template>
  <v-layout column>
    <v-flex xs11 offset-xs0>
      <panel v-bind:title='title'>
        
        <CemeteryEdit v-if ='$store.state.isEditor' slot="action"/>
        <div slot="top">
          <H3>People buried in this cemetery</H3>
          <PeopleSearchTable v-bind:forceCemeteryId="id" />
        </div>         
      </panel>
            
    </v-flex>
  </v-layout>
</template>

<script>

import Panel from "@/components/Panel" ;
import PeopleSearchTable from "@/components/PeopleSearchTable" ;
import CemeteryService from "@/services/CemeteryService" ;
import CemeteryEdit from "./CemeteryEdit" ;

export default {
  components: {
    Panel, PeopleSearchTable, CemeteryEdit 
  },
  data () {
    return {
      id: parseInt(this.$route.params.id),
      cemetery: {},
      title: "Loading Cemetery " + this.$route.params.id
    }
  },

  async mounted () {
    console.log("in cemetery mounted") ;

    await this.readData() ;
  },
  methods: {
    async readData () {

      const result = await CemeteryService.id(this.id) ;
      this.cemetery = result.data ;
      console.log("Back from us, this.cemetery=" + JSON.stringify(result)) ;
      var t = this.cemetery.name ;
      if (this.cemetery.place) {
        const p = this.cemetery.place ;
        if (p.town) t += ", " + p.town.v ;
        if (p.state) t += ", " + p.state.v ;
        if (p.country) t += ", " + p.country.v ;
      }
      this.title = t ;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cemetery.vue